/*
This script needs reference for focus. Make sure to use reference in parent class component. Each component class needs
it's own different reference.
This script doesn't work for text area as enter calls onBlur function. Will fix it later.
This script require 'show' as value of msg prop if there is no error msg to work otherwise checkmark icon won't display.
*/

import React, {useState, useEffect, useRef, useCallback} from "react";
import {IconCheckmark, IconPencil, IconX} from '@veneer/core';

const InlineEdit = ({
        text,
        type,
        placeholder,
        children,
        childRef,
        msg,
        isAlignRight,enabled,
                        ...props
        }) => {

            const componentRef = useRef(null);
            const [isEditing, setEditing] = useState(false);
            const [msgVisible, setMsgVisible] = useState(false);
            const [iconVisible, setIconVisible] = useState(false);
            const [icVis, setIcVis] = useState(false);
            const [clsName, setClsName] = useState('inlineX');
            const [width, setWidth] = useState(0);
            const [arr, setArr] = useState([]);
            const [errIcVis, setErrIcVis]= useState(false);

    const shorterMsg = useCallback((word) => {
        let sb =[];
        if(word==="" ||word===undefined){
            sb=[];
        }
        if(word!== undefined){
            let split = Math.floor(width/8)+5;
            let size = Math.floor((word.length/split)+1);
            let n=0;
            let m=0;
            let nu=0;
            let nu1=0;
            for (let i = 0; i < size; i++){
                if (i < size-1){
                    n = m;
                    m = m + split;
                    nu = word.charAt(m-1).charCodeAt(0);
                    nu1 = word.charAt(m).charCodeAt(0);

                    if(Number(nu)===32){
                        sb[i] = word.substring(n,m);
                    }
                    else{
                        if(Number(nu1)===32){
                            sb[i] = word.substring(n,m+1);
                            m=m+1;
                        }
                        else{
                            for(let j=m;j>0;j--){
                                if(Number(word.charAt(j).charCodeAt(0))===32){
                                    sb[i] = word.substring(n,j+1);
                                    m=j+1;
                                    break;
                                }
                            }
                        }
                    }
                }
                if(Number(i)===Number(size-1)){
                    n=m;
                    m = word.length;
                    sb[i] = word.substring(n,m);
                }
            }
        }
        setArr(sb);
    },[width])

            useEffect(() => {
               setEditing(false);
            }, [enabled]);

            useEffect(() => {
                    if (childRef && childRef.current && isEditing === true) {
                        childRef.current.focus();
                    }
                    if(msg!=="show"){
                        shorterMsg(msg);
                    }
                }, [isEditing,shorterMsg, childRef, msg]);


            const handleKeyDown = (event, type) => {
                };

            const onBlurFunc = () => {
                setEditing(false);
                setMsgVisible(true);
                setIconVisible(true);
                setTimeout(()=>setIconVisible(false), 2000);
                setTimeout(()=>setMsgVisible(false), 15000);
                };

            const onHoverIn = () => {
                setIcVis(true);
                setIconVisible(false);
                setClsName('inlineOutline');
                setWidth(componentRef.current.offsetWidth);
                };

            const onHoverOut = () => {
                setIcVis(false);
                setClsName('inlineX');
            }

            const onHoverInError = () => {
                setErrIcVis(true);
                }

            const onHoverOutError = () => {
                setErrIcVis(false);
            }

            const onClickFunc = () => {
                setEditing(true);
                setMsgVisible(false);
                setIconVisible(false);
                setIcVis(false);
                setClsName('');
                };

            const clearMsg = () => {
                setMsgVisible(false);
            }


            return (
            <section {...props}>
                {isEditing ? (
                    <div
                        onBlur={() => onBlurFunc()}
                        onKeyDown={e => handleKeyDown(e, type)}

                    >
                    {children}
                    </div>
                    ) : (
                     <div>
                        <div ref={componentRef} className={isAlignRight?'inline-edit '+clsName : 'inlineD '+clsName}
                             onClick={() => onClickFunc()}
                             onMouseEnter={()=>onHoverIn()}
                             onMouseLeave={()=>onHoverOut()}
                             >
                            <div>
                                {text}
                            </div>
                            {(msg==='show')?(
                                <div className="inlineE">
                                    {iconVisible && <div>
                                        {<IconCheckmark/>}
                                    </div>}
                                </div>
                                ):(
                                <div>
                                </div>)}
                                {icVis && <div className="inlineFade">
                                    {<IconPencil/>}
                            </div>}
                        </div>
                        {msgVisible && <div>
                            {(msg!=='show') ? (
                            <div className="inlineZ inlineS"
                                 onMouseEnter={()=>onHoverInError()}
                                 onMouseLeave={()=>onHoverOutError()}
                                 >
                                    <div>
                                        {arr.map((item) =>
                                            <div key={item}>{item}</div>
                                        )}
                                    </div>
                                    {errIcVis && <div className="inlineY" onClick={() => clearMsg()}>
                                        {<IconX/>}
                                    </div>}
                            </div>
                            ):(
                            <div>
                            </div>)}
                        </div>}
                    </div>
                    )}
            </section>
            );
        };


export default InlineEdit;